/**
 * Firebase client. Offline cache (persistentLocalCache) so gabbaim keep working without signal.
 * Local development runs against the emulators (VITE_USE_EMULATORS=true, demo project).
 */
import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import {
  enablePersistentCacheIndexAutoCreation, getPersistentCacheIndexManager,
  initializeFirestore, persistentLocalCache, persistentMultipleTabManager, connectFirestoreEmulator,
} from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getStorage, connectStorageEmulator } from 'firebase/storage';

export const USE_EMULATORS = import.meta.env.VITE_USE_EMULATORS === 'true';
const EMU_HOST = import.meta.env.VITE_EMULATOR_HOST || '127.0.0.1';

// Web config is public by design (security comes from Auth + rules).
const prodConfig = {
  apiKey: 'AIzaSyC62_erLlGAJ4v3k4Tuem7FMlObesBpk4k',
  authDomain: 'neevehapisga-77ced.firebaseapp.com',
  projectId: 'neevehapisga-77ced',
  storageBucket: 'neevehapisga-77ced.firebasestorage.app',
  messagingSenderId: '1058202284475',
  appId: '1:1058202284475:web:bd8c549d92120cf05b549e',
};
const emulatorConfig = { apiKey: 'demo-key', authDomain: 'localhost', projectId: 'demo-neevehapisga', appId: 'demo', storageBucket: 'demo-neevehapisga.appspot.com' };

export const app = initializeApp(USE_EMULATORS ? emulatorConfig : prodConfig);
export const auth = getAuth(app);
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
  ignoreUndefinedProperties: true,
});
export const functions = getFunctions(app, 'me-west1');
export const storage = getStorage(app);

if (USE_EMULATORS) {
  connectAuthEmulator(auth, `http://${EMU_HOST}:9099`, { disableWarnings: true });
  connectFirestoreEmulator(db, EMU_HOST, 8085);
  connectFunctionsEmulator(functions, EMU_HOST, 5001);
  connectStorageEmulator(storage, EMU_HOST, 9199);
}
// Local indexes for the offline cache (owner 2026-10-06, speed): without them every query first scans every cached doc
// of its collection (thousands of box rows / payments on a phone that once opened a big list). After the emulator
// connection — using Firestore before connectFirestoreEmulator throws (blank app in development).
try {
  const im = getPersistentCacheIndexManager(db);
  if (im) enablePersistentCacheIndexAutoCreation(im);
} catch { /* older browsers: the cache still works, only without local indexes */ }
